import React from "react";

export default function SegmentedControl({
  selectedBgColor,
  selectedTextColor,
  numbersAsOptions,
  startNumber,
  unselectedBgColor,
  unselectedTextColor,
  options,
  selected,
  setSelected,
  customClassNameOuterDiv,
  customClassNameInnerDiv,
  bold = true,
}) {
  const selectedColors = `${selectedBgColor} ${selectedTextColor}`;
  const unselectedColors = `${unselectedBgColor} ${unselectedTextColor}`;
  const renderOptions = options.map((option, index) => {
    index = index + startNumber;
    const preferredValueStructure = numbersAsOptions ? index : option;
    return (
      <div
        key={`segmented-control-option-${index}-${option}`}
        className={`w-full flex justify-center items-center select-none
        ${bold ? "font-semibold" : ""}
            ${
              selected === preferredValueStructure
                ? selectedColors
                : unselectedColors
            } 
             ${customClassNameInnerDiv}`}
        onClick={() => setSelected(preferredValueStructure)}
      >
        <p>{option}</p>
      </div>
    );
  });
  return (
    <div
      className={`overflow-hidden cursor-pointer w-full flex ${customClassNameOuterDiv}`}
    >
      {renderOptions}
    </div>
  );
}

// Hella proudly made by ponta


